import request from '@/utils/request'

// 聊天配置列表
export function spWorkWechatSpCorpChatConfigIndex(corp_primary_id) {
  return request({
    url: '/spWorkWechat/spCorp/chatConfigIndex',
    method: 'get',
    params: {
      corp_primary_id
    }
  })
}

// 添加
export function spWorkWechatSpCorpChatConfigAdd(data) {
  return request({
    url: '/spWorkWechat/spCorp/chatConfigAdd',
    method: 'post',
    data
  })
}
// 编辑
export function spWorkWechatSpCorpChatConfigUpdate(data) {
  return request({
    url: '/spWorkWechat/spCorp/chatConfigUpdate',
    method: 'post',
    data
  })
}
// 删除
export function spWorkWechatSpCorpChatConfigDel(id) {
  return request({
    url: '/spWorkWechat/spCorp/chatConfigDel',
    method: 'post',
    data: {
      id
    }
  })
}
// 内部群列表
export function spWorkWechatSpCorpInternalGroupList(params = {}) {
  return request({
    url: '/spWorkWechat/spCorp/internalGroupList',
    method: 'get',
    params
  })
}
// 状态修改
export function spWorkWechatSpCorpChatConfigSetStatus(data) {
  return request({
    url: '/spWorkWechat/spCorp/chatConfigSetStatus',
    method: 'post',
    data
  })
}
// 聊天tab列表
export function spWorkWechatspCorpindexForWw(params) {
  return request({
    url: '/spWorkWechat/spCorp/indexForWw',
    method: 'get',
    params
  })
}
